import React, { FC, ReactNode } from 'react';

import { StyledHeader, StyledHeaderContent, StyledHeaderRow } from './MainHeaderLayout.styles';

export interface MainHeaderLayoutProps {
  children: ReactNode;
  primary: boolean;
  horizontalLogo: boolean;
  padding: string;
  mdPadding: string;
  height: number;
  background: string;
}

const MainHeaderLayout: FC<MainHeaderLayoutProps> = ({ children, padding, mdPadding, ...props }) => (
  <StyledHeader {...props}>
    <StyledHeaderContent padding={padding} mdPadding={mdPadding}>
      <StyledHeaderRow align="center" nogutter nowrap>{children}</StyledHeaderRow>
    </StyledHeaderContent>
  </StyledHeader>
);

export default MainHeaderLayout;
